import ShareUtil from './ShareUtil';
import ShareKakaoLink from './ShareKakaoLink';

class ShareKakaoStory extends ShareKakaoLink{
  constructor( url ){
    super();
    this.url = url;

    function stopEvent(e) {
      if(!e) var e = window.event;
      e.cancelBubble = true;
      e.returnValue = false;
      if ( e.stopPropagation ) e.stopPropagation();
      if ( e.preventDefault ) e.preventDefault();
      return false;
    };

    function addEvent( el, handler ){
      if( el.addEventListener ){
        el.addEventListener("click", handler, false);
      }else if( el.attachEvent ){
        el.attachEvent("onclick", handler);
      }
    };

    let kakaoStoryBtn = document.getElementById( 'kakao-story-link-btn' ) ;
    let This = this;

    if( kakaoStoryBtn ){
      addEvent( kakaoStoryBtn, function( evt ){
        stopEvent( evt );

        let url = This.url || location.href,
          kakaoStoryShareUrl = 'https://story.kakao.com/share?url=',
          options = 'width=530, height=480, resizable=no, scrollbars=no, status=no';
        window.open( kakaoStoryShareUrl + decodeURIComponent( url ), 'kakaoStoryShare', options );
      })
    }
  }

  kakaoStorySimpleUrlLink( url = location.href ){
      let kakaoStoryShareUrl = 'https://story.kakao.com/share?url=',
      options = 'width=530, height=480, resizable=no, scrollbars=no, status=no';
    window.open( kakaoStoryShareUrl + decodeURIComponent( url ), 'kakaoStoryShare', options );
  }

  KakaoStoryLink( msg, url ){

    let errorMsg = '에러가 발생했습니다.',
      successMsg = '정상 처리 되었습니다.';

    let kakaoKey = this.setKey( location.href );

    this.msg = msg;

    this.init(function(){
      Kakao.Auth.login({
        success: function() {
          Kakao.API.request( {
          url : '/v1/api/story/linkinfo',
            data : {
            url : url || location.href
          }
          }).then(function(res) {
          return Kakao.API.request( {
            url : '/v1/api/story/post/note', //v1/api/story/post/info
            data : { content : msg }
          });
          }).then(function(res) {
          alert( successMsg );
          }, function (err) {
          alert( errorMsg );
          });

        },
        fail: function(err) {
          alert( errorMsg );
        //alert(JSON.stringify(err))
        }
      });
    });
  }
}

export default ShareKakaoStory;
